import { Component, OnInit, Optional } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Group, Query } from 'core-lib';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-group-picker',
  templateUrl: './group-picker.component.html',
  styleUrls: ['./group-picker.component.scss']
})
export class GroupPickerComponent implements OnInit {

  groups: Group[] = [];
  selectedGroup: Group;

  QUERY_GROUPS = gql`
  query listGroups{
    listGroups{
      id
      name
      numberOfMembers
      memberIds
    }}`;

  constructor(private apollo: Apollo, private messageService: MessageService, @Optional() private dialogRef: DynamicDialogRef,) {

  }

  /**
  * init
  */
  ngOnInit(): void {
    this.apollo.query<Query>({
      query: this.QUERY_GROUPS,
      variables: {}
    }).subscribe((result) => {
      this.groups = result.data.listGroups;
    });
  }

  /**
   * group selected
   */
  onAcceptGroup(): void {
    this.dialogRef.close(this.selectedGroup );
  }
}
